window.vue = require('vue');

import ProviderRegister from "./provider_panel/provider_register.vue";

import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faCalendarAlt, faAddressCard, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faUser, faCalendarAlt, faAddressCard, faCheckCircle);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueSweetalert2);
Vue.prototype.trans = (key) => {
    return _.get(window.lang, key, key);
};

//Main vue instance
new Vue({
    el: '#ProviderRegister',
    data: {},
    components: {
        ProviderRegister
    },
  
    created: function() {},
});